document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.product-page-slider')) {
        
        var trust_banner = new Glide('.product-page-slider', {
            type: 'carousel',
            perView: 4,
            gap: 0,
            startAt: 0,
            breakpoints: {
                1300: {
                    perView: 3,
                    autoplay: 3000
                },
                992: {
                    perView: 2,
                    autoplay: 3000
                },
                768: {
                    perView: 1,
                    autoplay: 3000
                }
            }
        });
    
        trust_banner.mount();
    }

    if (document.querySelector('.payment-slider')) {
        var paymentSlider = new Glide('.payment-slider', {
            type: 'carousel',
            perView: 1,
            gap: 0,
            startAt: 0,
            autoplay: 3000
        });

        let paymentSliderMounted = false;

        if (window.innerWidth < 768 && !paymentSliderMounted) {
            paymentSlider.mount();
            paymentSliderMounted = true;
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth > 768 && paymentSliderMounted) {
                paymentSlider.destroy();
                paymentSliderMounted = false;
            } else {
                if (window.innerWidth < 768 && !paymentSliderMounted) {
                    paymentSlider.mount();
                    paymentSliderMounted = true;
                }
            }
        })
    }
})